import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  to?: string | null;
}

const sizeMap = {
  sm: { box: 'h-7 w-7', text: 'text-sm', icon: 14 },
  md: { box: 'h-9 w-9', text: 'text-base', icon: 18 },
  lg: { box: 'h-12 w-12', text: 'text-xl', icon: 24 },
};

export default function Logo({ size = 'md', showText = true, to = null }: LogoProps) {
  const s = sizeMap[size];
  const content = (
    <div className="flex items-center gap-2">
      <div
        className={`flex ${s.box} items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-purple-600 shadow-lg shadow-brand-500/20`}
      >
        <svg width={s.icon} height={s.icon} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="logo-grad-inner" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
              <stop stop-color="#c7d2fe" />
              <stop offset="1" stop-color="#e9d5ff" />
            </linearGradient>
          </defs>
          <path d="M16 40 L20 24 L26 32 L32 20 L38 32 L44 24 L48 40 Z" fill="url(#logo-grad-inner)" opacity="0.98" />
          <path d="M16 40 L48 40 L46 44 L18 44 Z" fill="white" opacity="0.85" />
          <circle cx="32" cy="36" r="3" fill="url(#logo-grad-inner)" />
        </svg>
      </div>
      {showText && (
        <span className={`font-bold tracking-tight text-slate-950 dark:text-slate-100 ${s.text}`}>
          SAIK
        </span>
      )}
    </div>
  );

  if (to) {
    return <Link to={to}>{content}</Link>;
  }
  return content;
}